import React from 'react'
import { useEffect, useState, useMemo, useRef, useCallback } from 'react'

import { CCol, CRow, CCard, CCardBody, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem, CCardTitle, CCardText, CCardImage, CButton, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem, CFormSelect } from '@coreui/react'
import { CWidgetStatsA, CWidgetStatsD } from '@coreui/react'
import { CChartBar, CChartLine } from '@coreui/react-chartjs'
import Modal from '../../components/shared/Modal'
import getAllWorkData from '../../services/general/getAllWorkData.api.js'
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-enterprise'

import { LicenseManager } from 'ag-grid-enterprise'

LicenseManager.setLicenseKey('For_Trialing_ag-Grid_Only-Not_For_Real_Development_Or_Production_Projects-Valid_Until-21_December_2022_[v2]_MTY3MTU4MDgwMDAwMA==72993978b037cf7071dd20d6c116bd5d')

import 'ag-grid-community/styles//ag-grid.css'
import 'ag-grid-community/styles//ag-theme-material.css'

const WidgetWrapper = (options) => {
  const gridRef = useRef()

  const [title, setTitle] = useState('')

  const [value, setValue] = useState('')

  const [color, setColor] = useState('')

  const onClose = () => {
    setVisible(false)
  }

  const [visible, setVisible] = useState(false)

  const defaultColDef = useMemo(() => {
    return {
      enableRowGroup: true,
      enableValue: true,
      sortable: true,
      resizable: true,
      filter: true,
      flex: 1,
      minWidth: 300,
    }
  }, [])
  const [data, setData] = useState([])
  const [columns, setColumns] = useState([])

  const handleClick = async (e) => {
    // let c =[]
    // let loginID = options.accessCode ? options.accessCode : "1"
    // let chartData
    // if (value.includes("Not")) {
    //    chartData = await getAllWorkData(loginID,"Not Started")
    // } else if (value.includes("Progress")) {
    //   chartData = await getAllWorkData(loginID, "In Progress")
    // } else if (value.includes("Completed")) {
    //   chartData = await getAllWorkData(loginID, "Completed")
    // } else if (value.includes("Stopped")) {
    //   chartData = await getAllWorkData(loginID, "Stopped")
    // } else if (value.includes("Dropped")) {
    //   chartData = await getAllWorkData(loginID, "Dropped")
    // }
    //   let temp = JSON.parse(chartData.d)["Data"]
    //   for (let j = 0; j <Object.keys(temp[0]).length ; j++) {
    //     if (j == 0) {
    //      continue;
    //     } else {
    //       c.push({
    //         field: Object.keys(temp[0])[j],
    //         headerName:Object.keys(temp[0])[j],
    //       })
    //     }
    //   }
    //   setColumns(c)
    //   setData(temp)
    // setVisible(!visible)
  }

  useEffect(() => {
    setTitle(options.title)

    setValue(options.value)

    setColor(options.color)
  }, [options])

  const onBtExport = useCallback(() => {
    gridRef.current.api.exportDataAsExcel()
  }, [])
  const excelStyles = useMemo(() => {
    return [
      {
        id: 'multiline',
        alignment: {
          wrapText: true,
        },
      },
    ]
  }, [])

  return (
    <>
      <CWidgetStatsA
        style={{ borderRadius: '20px', opacity: '1  ' }}
        className="mb-4 shadow"
        onClick={handleClick}
        color={color}
        value={value}
        title={
          <>
            <span style={{ fontWeight: 'bold', fontSize: '20px' }}>{title}</span>
          </>
        }
        //   action={
        //     <CDropdown alignment="end">
        //       <CDropdownToggle color="transparent" caret={false} className="p-0">
        //         <CIcon icon={freeSet.cilOptions} className="text-high-emphasis-inverse" />
        //       </CDropdownToggle>
        //       <CDropdownMenu>
        //         <CDropdownItem>Action</CDropdownItem>
        //         <CDropdownItem>Another action</CDropdownItem>
        //         <CDropdownItem>Something else here...</CDropdownItem>
        //         <CDropdownItem disabled>Disabled action</CDropdownItem>
        //       </CDropdownMenu>
        //     </CDropdown>
        //   }
        chart={
          <CChartBar
            className="mt-3 mx-3"
            style={{ height: '70px' }}
            data={{
              labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December', 'January', 'February', 'March', 'April'],
              datasets: [
                {
                  label: 'My First dataset',
                  backgroundColor: 'rgba(255,255,255,.2)',
                  borderColor: 'rgba(255,255,255,.55)',
                  data: [78, 81, 80, 45, 34, 12, 40, 85, 65, 23, 12, 98, 34, 84, 67, 82],
                  barPercentage: 0.6,
                },
              ],
            }}
            options={{
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: false,
                },
              },
              scales: {
                x: {
                  grid: {
                    display: false,
                    drawTicks: false,
                  },
                  ticks: {
                    display: false,
                  },
                },
                y: {
                  grid: {
                    display: false,
                    drawBorder: false,
                    drawTicks: false,
                  },
                  ticks: {
                    display: false,
                  },
                },
              },
            }}
          />
        }
      />
      {visible && (
        <Modal open={visible} type="table" title={value} onClose={onClose}>
          <div
            className="ag-theme-material"
            style={{
              height: '38rem',
            }}
          >
            <button onClick={onBtExport} style={{ margin: '5px 0px', fontWeight: 'bold' }}>
              Export to Excel
            </button>

            <AgGridReact
              rowData={data}
              columnDefs={columns}
              defaultColDef={defaultColDef}
              pagination={true}
              suppressRowClickSelection={true}
              groupSelectsChildren={true}
              rowSelection={'multiple'}
              rowGroupPanelShow={'always'}
              sideBar={'filters'}
              suppressAutoSize={false}
              ref={gridRef}
              excelStyles={excelStyles}
            />
          </div>
        </Modal>
      )}
    </>
  )
}

export default React.memo(WidgetWrapper)
